import type { LocationDetail } from "./location.type";
import type { UseGetOptions } from "@/hooks/queries";

import { useGet } from "@/hooks/queries";

export const useGetLocation = (
  locationId?: string | number,
  options?: UseGetOptions<LocationDetail>
) => {
  const { data, ...queryResult } = useGet<LocationDetail>(
    "locations",
    locationId,
    options
  );

  return {
    location: data,
    ...queryResult,
  };
};
